import ExpensesPage from "../views/Expenses/Expenses";
import NewExpense from "../views/Expenses/NewExpense";
import AspectRatioIcon from "@material-ui/icons/AspectRatio";

export const expensesRoutes = [
  {
    collapse: true,
    name: "Gastos",
    icon: AspectRatioIcon,
    state: "expensesSection",
    inSidebar: true,
    isProtected: true,
    rule: "EXPENSE",
    views: [
      {
        path: "/registro_gastos",
        name: "Registro de Gastos",
        mini: "RG",
        component: ExpensesPage,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "EXPENSE",
      },
      {
        path: "/nuevo_registro_gasto",
        name: "Registro de Gasto",
        icon: AspectRatioIcon,
        component: NewExpense,
        layout: "/admin",
        inSidebar: false,
        isProtected: true,
        rule: "EXPENSE",
      },
    ],
  },
]